module.exports = "<select\n    ng-if=\"SettlementFilterCtrl.settlements.length\"\n    ng-model=\"SettlementFilterCtrl.settlement\"\n    ng-options=\"item.id as item.name for item in SettlementFilterCtrl.settlements\"\n>\n    <option value=\"\">Osiedle</option>\n</select>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/filters/settlement-filter/settlement-filter.html
// module id = 625
// module chunks = 0